import { GetServerSideProps } from "next";
import Head from "next/head";
import { StrapiAboutUs } from "~/shared-types";
import { findSingleType } from "~/strapi/api";
import { handleRequestError } from "~/utils/rollbar";
import Richtext from "~/components/Richtext";
import SingleType from "../SingleType";

type ServerSideProps = {
  page: StrapiAboutUs | null;
};

export const getServerSideProps: GetServerSideProps<ServerSideProps> = async (
  context
) => {
  const page = await findSingleType<StrapiAboutUs>("about-us").catch(
    handleRequestError(context.req, null)
  );

  return {
    props: {
      page,
    },
  };
};

export default function AboutUsPage({ page }: ServerSideProps) {
  return (
    <SingleType>
      <Head>
        <title>Butik Danmark - Om os</title>
        <meta
          name="description"
          content="Alt det gode danske håndværk - samlet ét sted"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <SingleType.Heading>Om os</SingleType.Heading>
      {page?.attributes.content && (
        <SingleType.Content>
          <Richtext content={page.attributes.content} />
        </SingleType.Content>
      )}
    </SingleType>
  );
}
